module.exports = __webpack_public_path__ + "img/bg_aviso.48d9ec14.png";